import React from 'react';

import './style.css'

const Header = () => {
    return(
        <header className="header-style-1 flex justify-between items-center p-4 bg-gray-100 shadow-md shadow-none bg-gray-100">
            <div className="flex items-center space-x-3">
                <img
                    src="https://mida-landing-page.s3.eu-central-1.amazonaws.com/mida_logo.png"
                    alt="Logo"
                    className="h-14 w-auto"
                />
                <h1 className="text-xl font-bold text-gray-800">MIDA SPED</h1>
            </div>

            <div className="text-right">
                <p className="text-sm font-medium text-gray-700">Tabanovce, Kumanovo, North Macedonia</p>
                <p className="text-sm font-medium text-gray-700">+389 78 325 876</p>
            </div>
        </header>
     )
        
}

export default Header;
